import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { API_BASE } from '../config'

const C = {
  g900:'#0D2218', g800:'#1A3A28', g700:'#235233', g600:'#2D6B42',
  g500:'#3D8A57', g400:'#5AAE73', g100:'#E8F5EE', g50:'#F2FAF5',
  white:'#FFFFFF', muted:'#5A7065', border:'#C8DDD2', error:'#C0392B',
}

const ROLES = [
  { value: 'doctor',  label: 'Doctor',          icon: '🩺' },
  { value: 'manager', label: 'Clinic Manager',   icon: '🏥' },
  { value: 'kt',      label: 'Skin Therapist (KT)', icon: '✨' },
]

const ROLE_FIELDS = {
  doctor: [
    { key: 'qualification',  label: 'Qualification (e.g. MBBS, MD)',  type: 'text', required: true },
    { key: 'specialization', label: 'Specialization',                  type: 'text', required: true },
    { key: 'experience',     label: 'Years of Experience',             type: 'text', required: true },
  ],
  manager: [
    { key: 'previousClinic',       label: 'Previous Clinic / Hospital', type: 'text', required: false },
    { key: 'managementExperience', label: 'Management Experience',      type: 'text', required: true },
  ],
  kt: [
    { key: 'certification', label: 'Certification / Training',         type: 'text', required: true },
    { key: 'treatments',    label: 'Treatments you specialize in',     type: 'text', required: true },
    { key: 'experience',    label: 'Years of Experience',              type: 'text', required: true },
  ],
}

export default function StaffRegister() {
  const navigate = useNavigate()
  const [step, setStep]   = useState('role')   // role | form | done
  const [role, setRole]   = useState('')
  const [form, setForm]   = useState({})
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const [msg, setMsg]     = useState('')

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }))

  const validateForm = () => {
    const e = {}
    if (!form.name?.trim())  e.name  = 'Name is required'
    if (!form.email?.trim()) e.email = 'Email is required'
    if (!form.phone?.trim()) e.phone = 'Phone is required'
    if (!form.password || form.password.length < 6) e.password = 'Minimum 6 characters'
    ;(ROLE_FIELDS[role] || []).forEach(f => {
      if (f.required && !form[f.key]?.trim()) e[f.key] = `${f.label} is required`
    })
    setErrors(e)
    return Object.keys(e).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) return
    setSubmitting(true)
    try {
      const res = await fetch(`${API_BASE}/api/staff/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ role, ...form }),
      })
      const data = await res.json()
      if (res.ok) {
        setStep('done')
      } else {
        setMsg(data.message || 'Registration failed.')
      }
    } catch {
      setMsg('Error connecting to server. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  const inp = (key, label, type = 'text', required = true) => (
    <div key={key}>
      <label style={{ fontSize: '.78rem', fontWeight: 600, color: C.muted, display: 'block', marginBottom: '.3rem' }}>
        {label} {required && <span style={{ color: C.error }}>*</span>}
      </label>
      <input
        type={type}
        value={form[key] || ''}
        onChange={e => set(key, e.target.value)}
        style={{ width: '100%', padding: '.7rem 1rem', border: `1.5px solid ${errors[key] ? C.error : C.border}`, borderRadius: 9, fontSize: '.875rem', outline: 'none', fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box' }}
      />
      {errors[key] && <div style={{ fontSize: '.72rem', color: C.error, marginTop: '.2rem' }}>{errors[key]}</div>}
    </div>
  )

  if (step === 'done') return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: C.g50, padding: '2rem' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 420, boxShadow: '0 4px 24px rgba(13,34,24,.08)', border: `1px solid ${C.border}`, textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
        <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.5rem', color: C.g900, marginBottom: '.75rem' }}>Application Submitted!</h2>
        <p style={{ fontSize: '.875rem', color: C.muted, lineHeight: 1.6, marginBottom: '1.5rem' }}>
          Thank you for applying to Revive Skin & Hair Clinic.<br />
          Our team will review your application and contact you within 24 hours.
        </p>
        <button onClick={() => navigate('/')} style={{ padding: '.8rem 2rem', borderRadius: 10, background: C.g700, color: 'white', border: 'none', fontSize: '.875rem', fontWeight: 600, cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>
          Back to Home
        </button>
      </div>
    </div>
  )

  if (step === 'role') return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: C.g50, padding: '2rem' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 460, boxShadow: '0 4px 24px rgba(13,34,24,.08)', border: `1px solid ${C.border}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1.75rem' }}>
          <span style={{ fontSize: '1.5rem' }}>🌿</span>
          <div>
            <div style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.4rem', color: C.g900 }}>Join Revive</div>
            <div style={{ fontSize: '.78rem', color: C.muted }}>Apply to work with our clinic</div>
          </div>
        </div>
        <div style={{ fontSize: '.78rem', fontWeight: 600, color: C.muted, marginBottom: '.75rem', textTransform: 'uppercase', letterSpacing: '.06em' }}>I am applying as a</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '.65rem' }}>
          {ROLES.map(r => (
            <button key={r.value} onClick={() => { setRole(r.value); setStep('form') }}
              style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem 1.25rem', border: `1.5px solid ${C.border}`, borderRadius: 12, background: 'white', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif", textAlign: 'left', transition: 'all .15s' }}
              onMouseEnter={e => { e.currentTarget.style.border = `1.5px solid ${C.g400}`; e.currentTarget.style.background = C.g50 }}
              onMouseLeave={e => { e.currentTarget.style.border = `1.5px solid ${C.border}`; e.currentTarget.style.background = 'white' }}>
              <span style={{ fontSize: '1.6rem' }}>{r.icon}</span>
              <div>
                <div style={{ fontWeight: 600, fontSize: '.9rem', color: C.g900 }}>{r.label}</div>
              </div>
              <span style={{ marginLeft: 'auto', color: C.muted, fontSize: '1rem' }}>→</span>
            </button>
          ))}
        </div>
        <button onClick={() => navigate(-1)} style={{ marginTop: '1.25rem', width: '100%', padding: '.7rem', borderRadius: 9, background: 'none', color: C.muted, border: `1px solid ${C.border}`, fontSize: '.82rem', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>
          ← Go Back
        </button>
      </div>
    </div>
  )

  const roleInfo = ROLES.find(r => r.value === role)
  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: C.g50, padding: '2rem' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 480, boxShadow: '0 4px 24px rgba(13,34,24,.08)', border: `1px solid ${C.border}` }}>
        <button onClick={() => setStep('role')} style={{ background: 'none', border: 'none', color: C.muted, fontSize: '.82rem', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif", marginBottom: '1.25rem', padding: 0 }}>
          ← Back
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1.75rem' }}>
          <span style={{ fontSize: '1.5rem' }}>{roleInfo?.icon}</span>
          <div>
            <div style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.3rem', color: C.g900 }}>{roleInfo?.label} Application</div>
            <div style={{ fontSize: '.75rem', color: C.muted }}>All fields marked * are required</div>
          </div>
        </div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '.9rem' }}>
          {inp('name',     'Full Name',      'text')}
          {inp('email',    'Email Address',  'email')}
          {inp('phone',    'Phone Number',   'tel')}
          {inp('password', 'Set Password (min 6 chars)', 'password')}
          {(ROLE_FIELDS[role] || []).map(f => inp(f.key, f.label, f.type, f.required))}
          {msg && <div style={{ fontSize: '.82rem', color: C.error, padding: '.75rem', background: '#FEF2F2', borderRadius: 8 }}>{msg}</div>}
          <button type="submit" disabled={submitting}
            style={{ padding: '.9rem', borderRadius: 10, background: submitting ? C.g400 : C.g700, color: 'white', border: 'none', fontSize: '.9rem', fontWeight: 600, cursor: submitting ? 'not-allowed' : 'pointer', fontFamily: "'DM Sans',sans-serif", marginTop: '.25rem' }}>
            {submitting ? 'Submitting…' : 'Submit Application'}
          </button>
        </form>
      </div>
    </div>
  )
}
